import {withFormikHandles} from "./with-formik-handles"
import {DropdownField} from "./dropdown-field"

export const FormikDropdownField = withFormikHandles(DropdownField)